import { t } from 'i18next';
import { ReactComponent as ArrowLeftIcon } from '../../../../icons/arrow.left.svg';

interface EditCollectedPhotoCardsHeaderProps {
  setIsShowFilterBottomDrawer: (isShow: boolean) => void;
  onHistoryBackClick: () => void;
  isCheckedPhotoCardFilter: boolean;
}

const EditCollectedPhotoCardsHeader = ({
  setIsShowFilterBottomDrawer,
  onHistoryBackClick,
  isCheckedPhotoCardFilter
}: EditCollectedPhotoCardsHeaderProps) => {
  return (
    <div className="flex items-center justify-between px-[16px] py-[8px] leading-none">
      <ArrowLeftIcon
        className="fill-main-light-1 dark:fill-main-dark-1"
        onClick={() => onHistoryBackClick()}
      />
      <h1 className="font-bold text-[17px] text-main-light-1 dark:text-main-dark-1">
        {t('photoCardPage.editCollectedPhotoCard')}
      </h1>
      <button
        type="button"
        onClick={() => setIsShowFilterBottomDrawer(true)}
        className={`text-[15px] ${
          isCheckedPhotoCardFilter
            ? 'text-primary-light dark:text-primary-dark'
            : 'text-main-light-3 dark:text-main-dark-3'
        }`}
      >
        {t('photoCardPage.filter')}
      </button>
    </div>
  );
};

export default EditCollectedPhotoCardsHeader;
